module.exports = __webpack_public_path__ + "media/images/icons/map-marker-faab0017d0e3745956d94962752eaa5e.svg";